export const PERFORMANCE_METRICS_SPREADSHEET_COMPANY = 'PERFORMANCE_METRICS_SPREADSHEET_COMPANY';
export const PERFORMANCE_METRICS_SPREADSHEET_HEADER_SUBTITLE = 'PERFORMANCE_METRICS_SPREADSHEET_HEADER_SUBTITLE';
export const PERFORMANCE_METRICS_SPREADSHEET_HEADER_TITLE = 'PERFORMANCE_METRICS_SPREADSHEET_HEADER_TITLE';
export const PERFORMANCE_METRICS_SPREADSHEET_RANK_ALIAS = 'PERFORMANCE_METRICS_SPREADSHEET_RANK_ALIAS';
